import { PERMISSIONS, ALL_PERMISSIONS } from "@/shared/consts/permissions";

export const DEMO_SEED_INTENT_KEY = "demo:seed-after-create";

export interface PreviewRoleOption {
  id: number;
  name: string;
  display_name_ru: string;
  display_name_kk: string;
  display_name_en: string;
}

export const PREVIEW_ROLE_OPTIONS: PreviewRoleOption[] = [
  { id: 1, name: "chief", display_name_ru: "Руководитель", display_name_kk: "Басшы", display_name_en: "Chief" },
  { id: 2, name: "pm", display_name_ru: "Руководитель проекта", display_name_kk: "Жоба жетекшісі", display_name_en: "Project manager" },
  { id: 3, name: "hr_manager", display_name_ru: "HR-менеджер", display_name_kk: "HR-менеджер", display_name_en: "HR manager" },
  { id: 4, name: "accountant", display_name_ru: "Бухгалтер", display_name_kk: "Бухгалтер", display_name_en: "Accountant" },
  { id: 5, name: "lawyer", display_name_ru: "Юрист", display_name_kk: "Заңгер", display_name_en: "Lawyer" },
  { id: 6, name: "admin", display_name_ru: "Администратор", display_name_kk: "Әкімші", display_name_en: "Administrator" },
  { id: 7, name: "contractor", display_name_ru: "Исполнитель ГПХ", display_name_kk: "АҚ орындаушысы", display_name_en: "GPH contractor" },
  { id: 8, name: "msb_contractor", display_name_ru: "Исполнитель МСБ", display_name_kk: "МСБ орындаушысы", display_name_en: "MSB contractor" },
];

export const PREVIEW_ROLE_PERMISSIONS: Record<string, string[]> = {
  chief: [...ALL_PERMISSIONS],
  pm: [...Object.values(PERMISSIONS.PROJECTS), ...Object.values(PERMISSIONS.SELF)],
  hr_manager: [...Object.values(PERMISSIONS.HR), ...Object.values(PERMISSIONS.SELF)],
  accountant: [...Object.values(PERMISSIONS.ACCOUNTING), ...Object.values(PERMISSIONS.SELF)],
  lawyer: [...Object.values(PERMISSIONS.LEGAL), ...Object.values(PERMISSIONS.SELF)],
  admin: [...Object.values(PERMISSIONS.ADMIN), ...Object.values(PERMISSIONS.SELF)],
  contractor: [
    ...Object.values(PERMISSIONS.SELF),
    PERMISSIONS.WAREHOUSE.VIEW_OWN_REQUESTS,
    PERMISSIONS.LEGAL.VIEW_AGREEMENTS,
    PERMISSIONS.LEGAL.CREATE_AGREEMENT,
    PERMISSIONS.LEGAL.EDIT_AGREEMENT,
  ],
  msb_contractor: [...Object.values(PERMISSIONS.SELF), PERMISSIONS.WAREHOUSE.VIEW_OWN_REQUESTS],
};
